// extracted by mini-css-extract-plugin
export default {"warningContent":"styles_warning-content__Lig-I"};